// extracted by mini-css-extract-plugin
export default {"content-preview-content":"ContentPreviewModal_content-preview-content__TTq7y","preview-frame":"ContentPreviewModal_preview-frame__8Hl-b"};